import { GetScrapFinanceAccountsApi } from "@/features/accounts/scrap-finance/services/get-accounts-api";
import { GetScrapFinanceAccountsRequestModel } from "@/features/accounts/scrap-finance/services/get-accounts-model";

/// 銀行口座一覧取得処理
export class GetScrapFinanceAccountsService {
  private getScrapFinanceAccountsApi = new GetScrapFinanceAccountsApi();

  /**
   * 銀行口座一覧取得API実行
   */
  public async getScrapFinanceAccounts(param: GetScrapFinanceAccountsRequestModel) {
    return await this.getScrapFinanceAccountsApi.getScrapFinanceAccounts(param);
  }
}
